
import React from 'react';
import { ImgTint } from "../../components/img-tint";
import { Redirect } from "react-router-dom";
import { DISPLAY_NEW_PASSWORD } from "../login-box/login-box";
import LoginBox from "../login-box";
import { css_file_to_url } from "../../helper/css-util";
import { dashboard_url } from "../../helper/dashboard_util";

class NewPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      new_pass_0: "",
      new_pass_1: "",
      loading: false,
    }
  }

  setNewPassword2 = (password_0, password_1) => {
    if (password_0 !== password_1) {
      this.props.setError("Passwords do not match");
      return;
    }
    this.props.setPasswordFromSession(password_0);
  };

  render = () => {
    const client = this.props.client;

    const {
      color,
    } = client;

    if (this.props.user.token) {
      const url = dashboard_url(this.props.user,
        this.props.dwolla, this.props.onboarding, this.props.app.wlf);
      return(<Redirect push to={url} />);
    }

    const container_style = {
      height: "35rem",
    };
    const login_style = {
      marginTop: "2rem",
      marginBottom: "0.1rem",
    };

    const landing_page_url = css_file_to_url(this.props.config, client.landing_page_image);


    return (
      <div>
        <div className="container-style-responsive" style={container_style}>
          <ImgTint img={landing_page_url} tint={color.top_panel_tint} />
          <LoginBox
            style={login_style}
            display={DISPLAY_NEW_PASSWORD}
            settingPassword={this.props.user.isFetching}
            onSetPassword={this.setNewPassword2}
            error={this.props.user.error}
            />
        </div>
      </div>
    );
  }
}

export { NewPassword };
